<template>
	<span class="initials">{{ signer.firstName[0] }}{{ signer.lastName[0] }}</span>
</template>
<script>
export default {
	props: {
		signer: { type: Object, required: true },
	},
};
</script>